export default __webpack_public_path__ + "static/media/boy-and-girl.fcf93f29.svg";